module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/fondeadores/reporteria/devoluciones-fondeo/devoluciones-fondeo.component.scss
// module id = ./src/app/administracion/fondeadores/reporteria/devoluciones-fondeo/devoluciones-fondeo.component.scss
// module chunks = main